module.exports = __webpack_public_path__ + "static/img/cs.3f9d8f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cs.png
// module id = cbHU
// module chunks = 128